// Estilos del formulario de inscripción rediseñado (v2).
// Están acotados a este formulario: no se modifica el tema global de la app
// porque los componentes compartidos (BuscarSelect, InputFile, ...) se usan en otras pantallas.
import { makeStyles } from "@material-ui/core/styles";
import { coloresEmma } from "../../../global/js/funciones";

export const ROJO = coloresEmma.secondarycolor;
const ROJO_OSCURO = coloresEmma.primarycolor;
const GRIS_TEXTO = "#6b6b6b";
const GRIS_BORDE = "#e4e4e4";

export const useEstilosInscripcion = makeStyles((theme) => ({
  // Opciones de las listas de los selectores: hasta dos líneas y, si no caben, "…".
  // Regla global porque react-select dibuja la lista fuera del formulario; solo existe mientras
  // el formulario v2 está en pantalla (Material UI la retira al desmontarlo).
  "@global": {
    "body .MuiMenuItem-root": {
      whiteSpace: "normal",
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      WebkitLineClamp: 2,
      overflow: "hidden",
      fontSize: 14,
      lineHeight: 1.35,
      paddingTop: 8,
      paddingBottom: 8,
    },
  },
  // Página a toda la altura de la pantalla para que el pie (Copyright) quede siempre abajo
  raiz: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
  },
  // Margen del 10 % a cada lado; en celular un margen fijo para no angostar el formulario
  pagina: {
    flex: "1 0 auto",
    padding: theme.spacing(3, 0),
    paddingLeft: "10%",
    paddingRight: "10%",
    [theme.breakpoints.down("xs")]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  },
  // Escritorio: formulario + columna derecha (Emma y ayuda). Desde md hacia abajo, una sola columna.
  distribucion: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr) 280px",
    gap: theme.spacing(3),
    alignItems: "start",
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "minmax(0, 1fr)",
    },
  },
  columnaLateral: {
    position: "sticky",
    top: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
  tarjetaLateral: {
    background: "rgba(255, 255, 255, 0.95)",
    border: `1px solid ${GRIS_BORDE}`,
    borderRadius: 16,
    padding: theme.spacing(2),
  },
  emma: {
    display: "block",
    width: "100%",
  },
  ayudaTitulo: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    fontSize: 15,
    fontWeight: 600,
    margin: theme.spacing(0, 0, 1),
  },
  ayudaTexto: {
    fontSize: 13,
    lineHeight: 1.55,
    color: GRIS_TEXTO,
    margin: 0,
  },
  banda: {
    display: "flex",
    gap: theme.spacing(1),
    alignItems: "flex-start",
    background: "#fff7f7",
    border: `1px solid ${GRIS_BORDE}`,
    borderRadius: 10,
    padding: theme.spacing(1.25, 1.5),
    marginBottom: theme.spacing(2),
    fontSize: 12.5,
    lineHeight: 1.5,
    color: "#555",
  },
  logo: {
    display: "block",
    margin: theme.spacing(1, "auto", 2),
    width: 170,
  },
  logoCabecera: {
    height: 44,
    [theme.breakpoints.down("xs")]: {
      height: 34,
    },
  },
  marca: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
  },
  separador: {
    alignSelf: "stretch",
    borderLeft: `1px solid ${GRIS_BORDE}`,
  },
  contenedor: {
    background: "rgba(255, 255, 255, 0.95)",
    border: `1px solid ${GRIS_BORDE}`,
    borderRadius: 16,
    padding: theme.spacing(3),
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(2),
    },
  },
  cabecera: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  titulo: {
    fontSize: 20,
    fontWeight: 600,
    margin: 0,
  },
  subtitulo: {
    fontSize: 13,
    color: GRIS_TEXTO,
    margin: 0,
  },
  progreso: {
    display: "grid",
    gap: 6,
    marginBottom: 6,
  },
  tramo: {
    height: 4,
    borderRadius: 2,
    background: GRIS_BORDE,
  },
  tramoActivo: {
    background: ROJO,
  },
  etiquetas: {
    display: "grid",
    gap: 6,
    marginBottom: theme.spacing(3),
  },
  etiqueta: {
    fontSize: 12,
    color: "#9a9a9a",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    [theme.breakpoints.down("xs")]: {
      visibility: "hidden",
    },
  },
  etiquetaActiva: {
    color: ROJO,
    fontWeight: 600,
    visibility: "visible !important",
  },
  tituloPaso: {
    fontSize: 18,
    fontWeight: 600,
    margin: 0,
  },
  descripcionPaso: {
    fontSize: 13,
    color: GRIS_TEXTO,
    margin: theme.spacing(0.5, 0, 2),
  },
  // Presentación de un paso con varios párrafos (inicio de la caracterización)
  introPaso: {
    margin: theme.spacing(0.75, 0, 0),
    fontSize: 13.5,
    lineHeight: 1.5,
    color: GRIS_TEXTO,
    "& p": { margin: theme.spacing(0, 0, 1) },
  },
  introDestacado: {
    margin: theme.spacing(0.5, 0, 1),
    padding: theme.spacing(1.25, 1.75),
    borderLeft: `3px solid ${ROJO}`,
    borderRadius: "0 8px 8px 0",
    background: "#fff7f7",
    fontSize: 13.5,
    lineHeight: 1.5,
    fontWeight: 600,
    color: "#3a3a3a",
  },
  seccion: {
    background: "#fff",
    border: `1px solid ${GRIS_BORDE}`,
    borderRadius: 12,
    padding: theme.spacing(3, 3.5),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(2),
    },
    // Ninguna etiqueta se parte en dos líneas: si no cabe, termina en "…"
    "& .MuiInputLabel-root": {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      maxWidth: "100%",
    },
    "& .MuiInputLabel-shrink": {
      maxWidth: "133%",
    },
  },
  seccionTitulo: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    fontSize: 15,
    fontWeight: 600,
    margin: theme.spacing(0, 0, 2.5),
  },
  // Iguala la altura del BuscarSelect (react-select) con la de los TextField (32 px)
  // para que las líneas inferiores queden alineadas. Solo aplica dentro de este formulario.
  campoSelect: {
    "& .MuiInputBase-input": {
      height: 32,
      padding: 0,
      boxSizing: "border-box",
      alignItems: "center",
    },
    "& .MuiInputBase-input > div:last-child > div": {
      paddingTop: 4,
      paddingBottom: 4,
    },
    // El valor seleccionado en una sola línea; si no cabe, termina en "…"
    "& .MuiInputBase-input > div:first-child": {
      flexWrap: "nowrap",
      minWidth: 0,
      overflow: "hidden",
    },
    "& .MuiInputBase-input > div:first-child > *": {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      maxWidth: "100%",
    },
  },
  // Selector marcado con error: BuscarSelect no tiene prop error, se pinta la línea y la etiqueta
  campoSelectError: {
    "& .MuiInputLabel-root": {
      color: theme.palette.error.main,
    },
    "& .MuiInput-underline:before, & .MuiInput-underline:after, & .MuiInput-underline:hover:not(.Mui-disabled):before": {
      borderBottom: `2px solid ${theme.palette.error.main}`,
      transform: "scaleX(1)",
    },
  },
  seccionIcono: {
    color: ROJO,
    fontSize: 20,
  },
  nota: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    fontSize: 12.5,
    color: "#8a5a00",
    marginTop: theme.spacing(0.75),
  },
  notaIcono: {
    fontSize: 16,
  },
  acciones: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: theme.spacing(1.5),
    marginTop: theme.spacing(3),
  },
  botonPrincipal: {
    textTransform: "none",
    borderRadius: 24,
    padding: theme.spacing(1, 3),
    background: ROJO,
    color: "#fff",
    "&:hover": {
      background: ROJO_OSCURO,
    },
    "&.Mui-disabled": {
      background: "#cfcfcf",
      color: "#fff",
    },
  },
  botonSecundario: {
    textTransform: "none",
    borderRadius: 24,
    padding: theme.spacing(1, 3),
    border: `1px solid ${GRIS_BORDE}`,
    color: "#444",
  },
  final: {
    textAlign: "center",
    padding: theme.spacing(4, 2),
  },
  finalMensaje: {
    maxWidth: 420,
    margin: theme.spacing(2, "auto"),
    textAlign: "justify",
    color: GRIS_TEXTO,
  },
  // Pie en una cápsula blanca translúcida para que contraste con la foto de fondo
  pie: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "wrap",
    gap: theme.spacing(1, 1.75),
    width: "fit-content",
    maxWidth: "calc(100% - 32px)",
    margin: theme.spacing(1, "auto", 3),
    padding: theme.spacing(0.75, 2.5),
    background: "rgba(255, 255, 255, 0.9)",
    backdropFilter: "blur(4px)",
    border: `1px solid ${GRIS_BORDE}`,
    borderRadius: 20,
    fontSize: 12.5,
    color: "#4a4a4a",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      gap: theme.spacing(0.5),
      borderRadius: 12,
      padding: theme.spacing(1, 2),
    },
  },
  pieSeparador: {
    color: "#b5b5b5",
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  pieEnlace: {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    color: ROJO,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  pieIcono: {
    fontSize: 15,
  },
  // Documentos: una fila por archivo (pendiente / cargado / con error)
  archivoFila: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.25, 1.5),
    border: `1px solid ${GRIS_BORDE}`,
    borderRadius: 10,
    background: "#fff",
    [theme.breakpoints.down("xs")]: {
      flexWrap: "wrap",
    },
  },
  archivoFilaError: {
    borderColor: theme.palette.error.main,
    background: "#fff7f7",
  },
  archivoFilaArrastre: {
    borderStyle: "dashed",
    borderColor: ROJO,
    background: "#fff7f7",
  },
  archivoIconoOk: { color: "#2e7d32" },
  archivoIconoPendiente: { color: "#b5b5b5" },
  archivoIconoError: { color: theme.palette.error.main },
  archivoTexto: {
    flex: 1,
    minWidth: 0,
  },
  archivoNombre: {
    fontSize: 14,
    margin: 0,
  },
  archivoDetalle: {
    fontSize: 12.5,
    color: GRIS_TEXTO,
    margin: 0,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  archivoDetalleError: {
    color: theme.palette.error.main,
    whiteSpace: "normal",
  },
  archivoAcciones: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    flexShrink: 0,
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      justifyContent: "flex-end",
    },
  },
  archivoBoton: {
    width: 32,
    height: 32,
    padding: 0,
    "& svg": { fontSize: 18 },
    background: ROJO,
    color: "#fff",
    "&:hover": { background: ROJO_OSCURO },
  },
  archivoBotonSecundario: {
    width: 32,
    height: 32,
    padding: 0,
    "& svg": { fontSize: 18 },
    border: `1px solid ${GRIS_BORDE}`,
    color: "#555",
  },
  archivoQuitar: {
    background: "none",
    border: "none",
    padding: 0,
    cursor: "pointer",
    fontSize: 13,
    color: GRIS_TEXTO,
    "&:hover": { textDecoration: "underline" },
  },
  archivoAyuda: {
    fontSize: 12.5,
    color: GRIS_TEXTO,
    margin: theme.spacing(-0.5, 0, 0),
  },
  // Caracterización: enunciado de la pregunta y sus opciones
  preguntaEnunciado: {
    fontSize: 14,
    lineHeight: 1.45,
    color: "#333",
    margin: theme.spacing(0, 0, 1.25),
  },
  preguntaError: {
    color: theme.palette.error.main,
  },
  preguntaOpcional: {
    color: GRIS_TEXTO,
  },
  // Única: píldoras en fila; en celular una debajo de otra
  opcionesUnica: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      alignItems: "stretch",
    },
  },
  opcionPildora: {
    border: `1px solid ${GRIS_BORDE}`,
    borderRadius: 999,
    background: "#fff",
    padding: theme.spacing(0.75, 2),
    fontSize: 13.5,
    fontFamily: "inherit",
    color: "#333",
    cursor: "pointer",
    transition: "background 0.15s, border-color 0.15s",
    "&:hover": { borderColor: ROJO },
    "&:focus-visible": { outline: `2px solid ${ROJO}`, outlineOffset: 2 },
  },
  opcionPildoraMarcada: {
    background: ROJO,
    borderColor: ROJO,
    color: "#fff",
    "&:hover": { background: ROJO_OSCURO, borderColor: ROJO_OSCURO },
  },
  // Múltiple: casillas en dos columnas; en celular una sola
  opcionesMultiples: {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    gap: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      gridTemplateColumns: "1fr",
    },
  },
  opcionCasilla: {
    display: "flex",
    alignItems: "center",
    gap: 2,
    border: `1px solid ${GRIS_BORDE}`,
    borderRadius: 10,
    background: "#fff",
    padding: theme.spacing(0.25, 1.25, 0.25, 0.25),
    fontSize: 13.5,
    lineHeight: 1.35,
    cursor: "pointer",
    "& .MuiCheckbox-root": { padding: 6 },
    "& .Mui-checked": { color: ROJO },
  },
  opcionCasillaMarcada: {
    borderColor: ROJO,
    background: "#fff7f7",
  },
  // Texto completo de la opción, debajo del corto
  opcionDetalle: {
    display: "block",
    marginTop: 2,
    fontSize: 12,
    lineHeight: 1.3,
    color: GRIS_TEXTO,
  },
  opcionesError: {
    "& $opcionPildora, & $opcionCasilla": {
      borderColor: theme.palette.error.main,
    },
  },
  contador: {
    textAlign: "right",
  },
  // Paso Confirmación: resumen por paso con "Editar"
  resumenFila: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: theme.spacing(1),
    padding: theme.spacing(1.25, 0),
    borderBottom: `1px solid ${GRIS_BORDE}`,
    "&:first-child": { paddingTop: 0 },
    "&:last-child": { borderBottom: "none", paddingBottom: 0 },
  },
  resumenPaso: {
    fontSize: 12,
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: 0.4,
    color: GRIS_TEXTO,
    margin: 0,
  },
  resumenDato: {
    fontSize: 14,
    margin: theme.spacing(0.25, 0, 0),
    wordBreak: "break-word",
  },
  resumenEditar: {
    color: ROJO,
    textTransform: "none",
    fontSize: 13,
    flexShrink: 0,
  },
  // Casillas de aceptación (mismo estilo que las de la caracterización)
  aceptacion: {
    display: "flex",
    alignItems: "flex-start",
    gap: 2,
    border: `1px solid ${GRIS_BORDE}`,
    borderRadius: 10,
    background: "#fff",
    padding: theme.spacing(0.75, 1.5, 0.75, 0.25),
    fontSize: 13.5,
    lineHeight: 1.45,
    cursor: "pointer",
    "& .MuiCheckbox-root": { padding: 6, marginTop: -3 },
    "& .Mui-checked": { color: ROJO },
    "& a": { color: ROJO, fontWeight: 600 },
  },
  aceptacionMarcada: {
    borderColor: ROJO,
    background: "#fff7f7",
  },
  aceptacionError: {
    borderColor: theme.palette.error.main,
  },
  // "Leer la declaración completa" bajo la casilla de datos sensibles
  declaracionEnlace: {
    border: "none",
    background: "none",
    padding: theme.spacing(0.75, 0, 0, 1),
    color: ROJO,
    fontSize: 13,
    fontWeight: 600,
    cursor: "pointer",
    textDecoration: "underline",
    fontFamily: "inherit",
  },
  declaracionCompleta: {
    marginTop: theme.spacing(1),
    padding: theme.spacing(1.5, 2),
    border: `1px solid ${GRIS_BORDE}`,
    borderRadius: 10,
    background: "#fafafa",
    fontSize: 13,
    lineHeight: 1.5,
    color: GRIS_TEXTO,
    textAlign: "justify",
    "& p": { margin: theme.spacing(0, 0, 1) },
    "& p:last-child": { marginBottom: 0 },
  },
  declaracionTitulo: {
    fontWeight: 600,
    color: "#3a3a3a",
    textAlign: "left",
  },
  // Error del último envío, dentro del paso Confirmación
  envioError: {
    display: "flex",
    alignItems: "flex-start",
    gap: theme.spacing(1.25),
    border: `1px solid ${theme.palette.error.main}`,
    background: "#fdecea",
    borderRadius: 10,
    padding: theme.spacing(1.5, 2),
    marginBottom: theme.spacing(2),
    "& p": { margin: 0, fontSize: 13.5, lineHeight: 1.45 },
  },
  envioErrorIcono: {
    color: theme.palette.error.main,
    marginTop: 1,
  },
  envioErrorTitulo: {
    fontWeight: 600,
    color: theme.palette.error.dark,
    marginBottom: "2px !important",
  },
  // Capa de "Enviando" sobre todo el formulario
  enviandoCapa: {
    position: "fixed",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 1400,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(2),
    background: "rgba(0, 0, 0, 0.55)",
  },
  // Sobre la capa oscura la tarjeta va sólida (la de carga es levemente transparente y aquí dejaba ver el formulario)
  enviandoTarjeta: {
    background: "#fff",
    boxShadow: "0 12px 32px rgba(0, 0, 0, 0.25)",
  },
  // Pantalla de inscripciones cerradas
  // Centra la tarjeta de cierre en el alto disponible (entre el borde superior y el pie)
  cierrePagina: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  cierreContenedor: {
    width: "100%",
    maxWidth: 820,
    margin: "0 auto",
  },
  cierreCuerpo: {
    display: "grid",
    gridTemplateColumns: "220px minmax(0, 1fr)",
    gap: theme.spacing(3),
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      gridTemplateColumns: "minmax(0, 1fr)",
      textAlign: "center",
    },
  },
  cierreImagen: {
    display: "flex",
    justifyContent: "center",
    "& img": {
      width: "100%",
      maxWidth: 220,
      maxHeight: 320,
      objectFit: "contain",
    },
    [theme.breakpoints.down("xs")]: {
      "& img": { maxWidth: 150 },
    },
  },
  cierreEtiqueta: {
    display: "inline-flex",
    alignItems: "center",
    gap: 5,
    fontSize: 12,
    fontWeight: 600,
    color: ROJO,
    border: `1px solid ${ROJO}`,
    borderRadius: 20,
    padding: theme.spacing(0.25, 1.25),
  },
  // Variante verde de la etiqueta para la pantalla de inscripción enviada
  etiquetaExito: {
    color: "#2e7d32",
    borderColor: "#2e7d32",
    background: "#edf7ee",
  },
  cierreTitulo: {
    fontSize: 20,
    fontWeight: 600,
    lineHeight: 1.35,
    margin: theme.spacing(1.5, 0, 1),
  },
  cierreTexto: {
    fontSize: 14,
    lineHeight: 1.6,
    color: GRIS_TEXTO,
    margin: theme.spacing(0, 0, 2),
  },
  cierreContacto: {
    border: `1px solid ${GRIS_BORDE}`,
    borderRadius: 10,
    padding: theme.spacing(1.25, 1.75),
    marginBottom: theme.spacing(2),
    textAlign: "left",
  },
  cierreContactoTitulo: {
    fontSize: 13.5,
    fontWeight: 600,
    margin: theme.spacing(0, 0, 0.5),
  },
  cierreContactoDato: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    fontSize: 13.5,
    color: GRIS_TEXTO,
    margin: 0,
  },
  cierreAcciones: {
    display: "flex",
    gap: theme.spacing(1),
    flexWrap: "wrap",
    [theme.breakpoints.down("xs")]: {
      justifyContent: "center",
    },
  },
  // Pantalla de carga: anillo que gira alrededor de la U y barra que se desplaza
  "@keyframes girar": {
    to: { transform: "rotate(360deg)" },
  },
  "@keyframes avanzar": {
    "0%": { left: "-40%" },
    "100%": { left: "100%" },
  },
  cargandoTarjeta: {
    width: "100%",
    maxWidth: 300,
    margin: "0 auto",
    textAlign: "center",
    background: "rgba(255, 255, 255, 0.95)",
    border: `1px solid ${GRIS_BORDE}`,
    borderRadius: 16,
    padding: theme.spacing(4, 3.5),
  },
  cargandoIndicador: {
    position: "relative",
    width: 64,
    height: 64,
    margin: theme.spacing(0, "auto", 2),
  },
  cargandoAnillo: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    border: `3px solid ${GRIS_BORDE}`,
    borderTopColor: ROJO,
    borderRadius: "50%",
    animation: "$girar 1s linear infinite",
    "@media (prefers-reduced-motion: reduce)": {
      animation: "none",
    },
  },
  cargandoSimbolo: {
    position: "absolute",
    top: "50%",
    left: "50%",
    width: 30,
    height: 30,
    transform: "translate(-50%, -50%)",
  },
  cargandoTitulo: {
    fontSize: 15,
    fontWeight: 600,
    margin: theme.spacing(0, 0, 0.5),
  },
  cargandoTexto: {
    fontSize: 13,
    color: GRIS_TEXTO,
    margin: theme.spacing(0, 0, 2),
  },
  cargandoBarra: {
    position: "relative",
    height: 3,
    borderRadius: 2,
    background: GRIS_BORDE,
    overflow: "hidden",
    "& span": {
      position: "absolute",
      top: 0,
      width: "40%",
      height: "100%",
      background: ROJO,
      animation: "$avanzar 1.2s ease-in-out infinite",
      "@media (prefers-reduced-motion: reduce)": {
        animation: "none",
        left: 0,
      },
    },
  },
  logoCuc: {
    width: 220,
    marginTop: theme.spacing(3),
  },
}));
